import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { MerchantShopMenuPage } from "./../merchant-shop-menu/merchant-shop-menu";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Http, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-your-shop",
  templateUrl: "merchant-your-shop.html",
})
export class MerchantYourShopPage {
  plaza = "";
  spaces: any = [1];
  display = false;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.storage.get("info").then((info) => {
      if (info.team.plaza_id == 1) {
        this.plaza = "A";
      } else if (info.team.plaza_id == 2) {
        this.plaza = "B";
      } else if (info.team.plaza_id == 3) {
        this.plaza = "C";
      } else if (info.team.plaza_id == 4) {
        this.plaza = "D";
      } else if (info.team.plaza_id == 5) {
        this.plaza = "E";
      } else if (info.team.plaza_id == 6) {
        this.plaza = "F";
      } else {
        this.plaza = info.team.plaza_id;
      }
    });
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantShop;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.spaces = data;
            this.display = true;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantShop;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.spaces = data;
            this.display = true;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
    refresher.complete();
  }

  link(space) {
    this.storage.get("roundGame").then((roundGame) => {
      this.storage.get("currentStep").then((currentStep) => {
        if (roundGame > 1 && currentStep == 5) {
          this.navCtrl.push(MerchantShopMenuPage, { space: space });
        }
      });
    });
  }

  backPage() {
    this.navCtrl.push(MerchantHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-your-shop/merchant-your-shop.ts